<template>
  <div>
    <div id="search">
      <el-row style="height: 40px">
        <el-button plain type="primary" size="small" @click="gotoItem" style="margin-right: 20px; margin-left: 20px">返回商品管理</el-button>
        <el-button type="primary" size="small" @click="startSku">同步SKU信息</el-button>

        <el-input v-model="title" size="small" style="width: 200px"></el-input>
        <el-button type="primary" size="small"  @click="getSkuData" >搜索</el-button>
      </el-row>

      <div class="block" align="center">
        <span class="demonstration"></span>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageObject.pageCurrent"
          :page-sizes="[20, 50, 100, 500, 1000, 2000]"
          :page-size="pageObject.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageObject.rowCount">
        </el-pagination>
      </div>
    </div>

    <el-button type="primary" size="mini" @click="hide">全屏显示/恢复</el-button>
    <el-row>
      <el-col :span="24">
        <el-table border style="font-size: 12px"  :data="skuData" :header-cell-style="{background:'#F2F6FC',color:'#000'}" :row-class-name="tableRowClassName" :span-method="objectSpanMethod">

          <el-table-column  prop="numIid" label="num_iid" width="120px"></el-table-column>
          <el-table-column  prop="skuId" label="sku_id" width="120px"></el-table-column>
          <el-table-column  prop="properties" label="properties" width="300px"></el-table-column>
          <el-table-column  prop="propImg" label="prop_img" width="600px"></el-table-column>
          <el-table-column  prop="quantity" label="quantity" width="80px"></el-table-column>
          <el-table-column  prop="price" label="price" width="80px"></el-table-column>
          <el-table-column  prop="created" label="created" width="240px"></el-table-column>
          <el-table-column  prop="modified" label="modified" width="240px"></el-table-column>
          <el-table-column  prop="status" label="status" width="240px"></el-table-column>
          <el-table-column  prop="propertiesName" label="properties_name" width="240px"></el-table-column>
          <el-table-column  prop="outerId" label="outer_id" width="240px"></el-table-column>
          <el-table-column  prop="" label="barcode" width="240px"></el-table-column>


        </el-table>
      </el-col>
    </el-row>


  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

  export default {
    name: "SkuFull",
    data(){
      return{
        title:'',
        rspan:1,
        cspan:1,
        display:1,
        skuData:[],
        pageObject: {
          pageCurrent: 1,
          rowCount: 0,
          pageSize: 100
        },
        timer:null,
        funName:'',
        cnName:'',
        //同步完成后提示
        msg:"",
      }
    },
    methods:{
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (1==0) {
          if ((columnIndex == 0) || ((columnIndex == 1))) {
            let rowcnt = row.skuCnt;
            let rownum = row.skuNum;

            let lpage = this.pageObject.pageCurrent;
            let lpagesize = this.pageObject.pageSize;

            let rspan = 1;
            let cspan = 1;
            //只要是第0行，不管序号是否为1
            if ((rowIndex == 0) || (rownum == 1)) {
              if (rowcnt - rownum + 1 > lpagesize - rowIndex) {
                rspan = lpagesize - rowIndex;
              } else {
                rspan = rowcnt - rownum + 1
              }
              //rspan = 5;
              cspan = 1;
            } else {
              rspan = 0;
              cspan = 0;
            }
            return {
              rowspan: rspan,
              colspan: cspan
            }
          }
        }
      },
      hide:function(){
        this.display++;
        if(this.display % 2 == 0){
          window.document.getElementById("left").style.display = 'none';
          window.document.getElementById("top").style.display = 'none';
          window.document.getElementById("search").style.display = 'none';
        }else {
          window.document.getElementById("left").style.display = 'block';
          window.document.getElementById("top").style.display = 'block';
          window.document.getElementById("search").style.display = 'block';
        }

      },
      //改变pageSize
      handleSizeChange: function (val) {
        this.pageObject.pageSize = val;
        this.getSkuData();
      },
      //当前页面改变
      handleCurrentChange: function (val) {
        this.pageObject.pageCurrent = val;
        this.getSkuData();
      },
      getSkuData:function () {
        let param={
          nick: storage.get("nick"),
          title:this.title,
          pageCurrent: this.pageObject.pageCurrent,
          rowCount: this.pageObject.rowCount,
          pageSize: this.pageObject.pageSize,
        }
        $api.post("/item/getSkuFull", param, response =>{
          let dataResult =  response.data;
          console.log(dataResult);
          if(dataResult.state == 1 && dataResult.message == "ok"){
            this.skuData = dataResult.data.sku;

            let pageObject = dataResult.data.pageObject;
            this.pageObject.rowCount = pageObject.rowCount;
            this.pageObject.pageSize = pageObject.pageSize;
          }else{
            this.$message.error(dataResult.message);
            this.$router.replace({name: "Index"});
          }
        })
      },

      //轮询同步状态
      getStatus:function () {
        this.msg='';
        let param={
          nick:storage.get("nick"),
          subNick:storage.get("subnick"),
          funName:this.funName,
          status:"1",
        }
        $api.post("/trade/getStatus", param, response =>{
          let dataResult =  response.data;
          if(dataResult.data == "success") {
            this.getSkuData();
            clearTimeout(this.timer);
            this.$message.success("【"+this.cnName +"】数据同步完成。");
            this.msg="【"+this.cnName +"】数据同步完成。";
          }
          else {
            this.timer = setTimeout(this.getStatus, 3000);
            this.msg='running';
            this.$message.warning("【"+this.cnName +"】数据同步中.....");
          }

        })
      },

      startSku:function() {
        this.$confirm('即将开始从淘宝获取数据，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
          this.getTbSku();
        })
      },

      getTbSku :function(){
        this.funName="GetSkus";
        this.cnName=" SKU ";

        let param ={
          nick: storage.get("nick"),
          subnick: storage.get("subnick"),
          allItem:'all',
        }
        $api.post("/item/getTbSku", param , response =>{
          let dataResult =  response.data;
          if(dataResult.state == 1 && dataResult.message == 'ok'){
            this.timer = setTimeout(this.getStatus, 1000);
          }else{
            this.$message.error(dataResult);
          }
        })
      },
      updateMemo:function (index, row) {
        let param ={
          nick:storage.get("nick"),
          skuId: row.skuId,
          shortName: row.shortName,
          cost:row.cost,
        };
        $api.post("/item/updateSkuShortName", param, response => {
          let dataResult = response.data;

          if (dataResult.state == 1 && dataResult.message == "ok") {
            this.$message({
              type: 'success',
              message: '恭喜，设置简称成本价成功！'
            });
          }else {
            this.$message.error(dataResult);
          }
        })
      },
      gotoItem:function(){
        this.$router.replace({name: 'ItmFull'});
      },
    },
    mounted(){
      this.getSkuData();
    }
  }
</script>

<style >
  a{
    color: #409EFF;
    text-decoration: none;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

</style>



// WEBPACK FOOTER //
// src/custom/SkuFull.vue